import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Bestätigungsdialog zum Löschen eines Messpunkts.
 * Zeigt Messpunkt-Nr und optional Tätigkeit/Notiz.
 */
function DeleteMeasurementDialog({ measurement, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!measurement) return null;

  return (
    <div className="edit-overlay" onClick={onCancel}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-header">
          <h3>{t('dialog.measurement_delete.title')}</h3>
          <button className="btn-close" onClick={onCancel} type="button">×</button>
        </div>
        <div className="edit-content">
          <p style={{ fontSize: '1rem', color: '#374151', lineHeight: '1.6' }}>
            {t('dialog.measurement_delete.confirm_empty', { number: measurement.number })}
          </p>
          {measurement.activity && (
            <div className="edit-info">
              <div><strong>{t('dialog.measurement_delete.taetigkeit')}</strong> {measurement.activity}</div>
            </div>
          )}
          {measurement.note && (
            <div className="edit-info">
              <div><strong>{t('dialog.measurement_delete.notiz')}</strong> {measurement.note}</div>
            </div>
          )}
        </div>
        <div className="edit-actions">
          <button className="btn btn-danger" onClick={onConfirm} type="button">
            {t('dialog.delete')}
          </button>
          <button className="btn btn-secondary" onClick={onCancel} type="button">
            {t('dialog.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteMeasurementDialog;
